import React from "react";

function CardLabelComponent(props) {

    return (
        <div className="mb-1">
            <label htmlFor={props.id} className="card-label">{props.label}</label>
        </div>
    );
}

export default CardLabelComponent;
